import React from 'react';
import { twMerge } from 'tailwind-merge';

const Component = ({
  title,
  subtitle,
  customClassName,
  customContainerClassName,
  children,
}: {
  title: string;
  subtitle?: string;
  customClassName?: string;
  customContainerClassName?: string;
  children?: React.ReactElement;
}) => (
  <div
    className={twMerge(
      'flex flex-col md:flex-row py-4 font-ibm justify-between gap-3',
      customContainerClassName,
    )}
  >
    <div className="flex flex-row gap-4">
      <h1 className={twMerge('text-xl font-bold', customClassName)}>{title}</h1>
      {subtitle && <p className="text-lg text-gray-500">{subtitle}</p>}
    </div>

    {children}
  </div>
);

export default Component;
